// ===== Mobile Sticky Bar =====
(function() {
  const bar = document.getElementById('mobile-sticky-bar');
  if (!bar) return;

  const productForm = document.querySelector('product-form') 
    || document.querySelector('.product-form')
    || document.querySelector('[data-product-form]');
  
  // 滚动触发显示/隐藏
  const triggerEl = document.querySelector('.product-form__buttons')
    || document.querySelector('.product__buy-buttons')
    || productForm;

  function checkScroll() {
    if (!triggerEl) return;
    const rect = triggerEl.getBoundingClientRect();
    if (rect.bottom < 0) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });

  // 颜色色块点击 → 同步主页面变体
  bar.querySelectorAll('.mobile-sticky-bar__swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      const value = this.dataset.value;
      
      // 更新 sticky bar 色块状态
      bar.querySelectorAll('.mobile-sticky-bar__swatch').forEach(function(s) {
        s.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // 触发主页面对应的变体按钮/选择器
      const mainSwatch = document.querySelector(
        `.swatch__button[data-value="${value}"], 
         [data-swatch="${value}"],
         .color-swatch[data-value="${value}"]`
      );
      if (mainSwatch) mainSwatch.click();

      // 更新价格
      setTimeout(function() {
        const mainPrice = document.querySelector('.price__regular .price-item--regular, .price .price-item');
        if (mainPrice) {
          document.getElementById('mobile-sticky-price').textContent = mainPrice.textContent.trim();
        }
      }, 100);
    });
  });

  // 加购按钮点击 → 触发主页面加购
  document.getElementById('mobile-sticky-atc').addEventListener('click', function() {
    const mainAtcBtn = document.querySelector(
      '[name="add"], .product-form__submit, #AddToCart'
    );
    if (mainAtcBtn && !mainAtcBtn.disabled) {
      mainAtcBtn.click();
    }
  });

})();
